// src/components/filter.
import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { useLocation, useNavigate } from 'react-router-dom';

import {
    Table,
    Col,
    Row,
    UncontrolledTooltip,
} from "reactstrap"
import { IoIosAdd } from "react-icons/io";



//import components
import Breadcrumbs from 'components/_Common/Breadcrumb';
import { useDispatch, useSelector } from "react-redux";

// actions
import { listBatchTrack, listParticipantsTrack } from "store/actions";
import { withTranslation } from "react-i18next";
import { MdArrowBackIos } from "react-icons/md";


const BatchParticipantTrack = props => {
    //meta title
    document.title = `${props.t("Batch Track")}  | ${props.t("Admin")}`;
    const {state} = useLocation();
    const { error, success, loading } = useSelector(state => ({
        loading: state.Batches.loading,
        error: state.Batches.error,
        success: state.Batches.success,
    }));
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [tableData, SetTableData] = useState([]);

    // list
    const fetchLisTrack = (filterData) => {
        dispatch(listParticipantsTrack(state?.batchId, state?.participantData?.id, (res) => {
            if (res?.status === 'success') {
                SetTableData([res?.data])
            }
        }))
    }
    useEffect(() => {
        fetchLisTrack()
    }, [])

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <div className="text-icon-back">
                        <MdArrowBackIos style={{ cursor: "pointer" }} onClick={() => navigate(-1)} /> <Breadcrumbs isBack = 'yes' title={props.t("Participants")} breadcrumbItem={props.t("Batches List")} breadcrumbItemText={props.t("Batches Track")} />
                    </div>
                    <Row>
                        <Col lg="12">
                            <div className="table-responsive rater-invite-list-table">
                                {
                                    loading ?
                                        <div className="loader d-flex justify-content-center align-items-center mt-5" >
                                            <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                                            {props.t("Loading")}
                                        </div>
                                        :
                                        <div>
                                            {
                                                tableData?.length <= 0
                                                ?
                                                    <div className="text-center no-record-found">{props.t("No Record Found")}</div>
                                                :
                                                    tableData?.map((data, index) => {
                                                        return (
                                                            <>
                                                            <div className="participant-title">{data?.participant_name}</div>
                                                                <Table className="table mb-0 invitation">
                                                                <thead>
                                                                    <tr>
                                                                        <th>{props.t("Rater Type")}</th>
                                                                        <th>{props.t("Invite Sent")}</th>
                                                                        <th>{props.t("Pending")}</th>
                                                                        <th>{props.t("In-Progress")}</th>
                                                                        <th>{props.t("Complete")}</th>
                                                                        <th>{props.t("Total Invites")}</th>
                                                                    </tr>
                                                                </thead>
                                                                {
                                                                    <tbody>
                                                                        {(data?.tracking || []).map((item, index) => (
                                                                            <tr key={index}>
                                                                                <td>{item?.rater_type?.split('_')
                                                                                    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                                                                    .join(' ')}
                                                                                </td>
                                                                                <td>
                                                                                    <label className="question-radio rater-invite-check">
                                                                                        <input type="checkbox" readOnly checked={item?.invite_sent == "yes" ? true : false} />
                                                                                        <span className="question-radio-click"></span>
                                                                                    </label>
                                                                                </td>
                                                                                <td>{item?.pending || 0}</td>
                                                                                <td>{item?.progress}</td>
                                                                                <td>{item?.complete || 0}</td>
                                                                                <td>{item?.total_invites || 0}</td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                }
                                                            </Table>
                                                        </>
                                                        )
                                                    })
                                            }

                                        </div>
                                }
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </React.Fragment>
    );
}

BatchParticipantTrack.propTypes = {
    history: PropTypes.object,
    t: PropTypes.any,

};

export default withTranslation()(BatchParticipantTrack);
